import React from 'react';
import IconTag from './iconTag';
import TextTag from './textTag';
import { getTagAttributes } from './tagAttributes';
import MatchingIcon from '../icons/matchingIcon';

const Tag = (props) => {
	const { tag, matching } = props;
	let {
		name, color, tooltip, image, className
	} = props;
	try {
		if (typeof tag !== 'undefined') {
			({
				name, color, tooltip, image,
			} = getTagAttributes(tag));
		}
	} catch (err) {
	}

	if (props.design === 'icon') {
		return <IconTag name={name} color={color} className={props.className} style={props.style} design={props.design} id={props.id} tooltip={tooltip} showTooltip={props.showTooltip} image={image} />;
	}
	//  if (props.tag === 'matching') {
	// 	return <MatchingIcon height={30} matchingPercentage={props.matchingPercentage} id={props.id}/>
	// }
	return <TextTag name={name} color={color} className={props.className} style={props.style} design={props.design} id={props.id} tooltip={tooltip} showTooltip={props.showTooltip} />;
};

export default Tag;
